import { render, staticRenderFns } from "./PhuSlot.vue?vue&type=template&id=51aff246&scoped=true"
import script from "./PhuSlot.vue?vue&type=script&lang=js"
export * from "./PhuSlot.vue?vue&type=script&lang=js"
import style0 from "./PhuSlot.vue?vue&type=style&index=0&id=51aff246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aff246",
  null
  
)

export default component.exports